export const API_DOC_URL = 'https://developers.heypongo.com/'
